export default __webpack_public_path__ + "static/media/warforged.38d5df99.jpeg";